import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BaseListComponent} from "../base-list/base-list.component";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../template/template.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CrudService} from "../service/crud.service";
import {BaseEditComponent} from "../base-edit/base-edit.component";
import {EInputType, IEditConfig} from "../../../interface/table.config";
import {ICrudRes} from "../../../interface/http.config";
import {Validators} from "@angular/forms";
import {listFromMap} from "../../../helper/list.helper";

@Component({
  selector: 'app-client-log-edit',
  standalone: true,
  imports: [
    BaseListComponent,
    NgIf,
    TemplateComponent,
    BaseEditComponent
  ],
  templateUrl: './client-log-edit.component.html',
  styleUrl: './client-log-edit.component.scss'
})
export class ClientLogEditComponent implements OnInit {
  data: ICrudRes;
  id: string | null = null;

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected cdr: ChangeDetectorRef,
              protected crudService: CrudService) {

  }
  clientList: {value: string; label: string}[] = [];

  editLink = '/dashboard/client-log-edit/';
  menuLink = '/dashboard/client-log';
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || null;

    this.crudService.provider = 'client-log';

    if (this.editConfig.groups.length && this.id) {

      this.editConfig.groups[0].configs = [
        {
          field: 'id',
          type: EInputType.DISABLED,
          name: 'Id',
          validators: [],
        },
        ...this.editConfig.groups[0].configs
      ];

      this.getItem();
    } else {
      this.data = {} as any;
    }

    this.crudService.getList('client', 'id', 'email').then(data => {
      this.clientList = listFromMap(data);

      this.cdr.detectChanges();
    });
  }

  editConfig: IEditConfig = {
    groups: [
      {
        name: 'General (New Manager Role)',
        configs: [
          {field: 'createdAt', name: 'Created At', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'clientId', name: 'Client', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'action', name: 'Action', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'details', name: 'Details', type: EInputType.TEXTAREA, validators: [Validators.required]},
        ]
      }
    ]
  };

  getItem() {
    this.crudService.item({id: this.id}).then(item => {
      this.data = item;

      this.editConfig.groups[0].name = 'General (Manager Role ' + item.name + ')';
    }).catch(console.error);
  }

  onAction(actionName: string, item: any) {
    if (actionName === 'submit') {
      this.crudService.save(item).then((data) => {
        if (!item.id) {
          this.router.navigate([this.editLink + '/' + data.document.id]).catch(console.error);
        } else {
          this.getItem();
        }
      });
    }

    if (actionName === 'back') {
      this.router.navigate([this.menuLink]).catch(console.error);
    }
  }
}
